<template>
  <select :id="thefield" :name="thefield" :value="getValue(thefield)" @change="setValue(thefield, $event.target.value)">
    <slot />
  </select>
</template>
<script setup lang="ts">
import { inject } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

const props = defineProps<{
  field?: string
  required?: any
}>()

const { setValue, getValue } = usePaymentForm()
const thefield = inject<string>('field', undefined) || props.field
</script>
<style scoped lang="scss">
select {
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f7f9fb;
  color: #222;
  cursor: pointer;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  min-width: 80px;
  transition: border-color 0.3s ease-in-out;
  font-size: 16px;
  align-items: center;
  box-shadow: none;
  display: inline-flex;
  height: 44px;
  justify-content: flex-start;
  padding: 0 10px;
  position: relative;
  @media only screen and (min-width: 720px) {
    height: 42px;
  }

  &:hover {
    border-color: $color-blue;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
  &:focus {
    border-color: $color-blue;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }
}
</style>